var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_5023)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#6C757E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.805 29.2941L33.551 22.0065C32.7501 21.438 31.8025 21.0957 30.8131 21.0173C29.8238 20.9389 28.8314 21.1276 27.9459 21.5625C27.0604 21.9973 26.3164 22.6613 25.7965 23.4809C25.2765 24.3004 25.0008 25.2435 25 26.2057V40.7882C24.9985 41.7513 25.2727 42.6959 25.7922 43.5168C26.3116 44.3378 27.056 45.0029 27.9423 45.4382C28.8287 45.8735 29.8223 46.0618 30.8125 45.9822C31.8027 45.9026 32.7508 45.5583 33.551 44.9874L43.805 37.6998C44.4853 37.2158 45.0386 36.5834 45.4199 35.8537C45.8013 35.124 46 34.3175 46 33.4996C46 32.6816 45.8013 31.8751 45.4199 31.1454C45.0386 30.4157 44.4853 29.7833 43.805 29.2993V29.2941Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_5023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlay);
export default __webpack_public_path__ + "static/media/audio-play.0094e7ab09c20df7b01e87941cf3ac3a.svg";
export { ForwardRef as ReactComponent };